import {
  CreateDocumentsUploadProcessDocument,
  CreateDocumentsUploadProcessMutation,
  CreateDocumentsUploadProcessMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateUploadProcess = () => {
  const [mutate, { loading }] = useMutation(CreateDocumentsUploadProcessDocument, {
    extractorFn: (data: CreateDocumentsUploadProcessMutation) =>
      data.documentsMutations.createDocumentsUploadProcess,
  })

  const createUploadProcess = (variables: CreateDocumentsUploadProcessMutationVariables) => {
    return mutate({
      variables,
    })
  }

  return { createUploadProcess, loading }
}
